import { render } from "./UIFilterSelect.vue?vue&type=template&id=23331c7e&ts=true"
import script from "./UIFilterSelect.vue?vue&type=script&lang=ts"
export * from "./UIFilterSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__